/**
 * OlogiesWrapper - Fetches and displays the Astro ologies content within the main site
 */
export default class OlogiesWrapper {
  constructor(container) {
    this.container = container;
    this.ologies = [];
    this.filteredOlogies = [];
    this.searchTerm = '';
    this.selectedType = 'all';
  }

  async render() {
    this.container.innerHTML = `
      <div class="ologies-wrapper">
        <div class="ologies-content-container">
          <div class="ologies-header">
            <h1><span class="ologies-title">'Ologies'</span> —is our content: the art-science of apps, design, and distribution.</h1>
            
            <div class="ologies-social">
              <span class="social-text">Follow us to stay in-the-know:</span>
              <div class="social-icons">
                <a href="#" class="social-icon" aria-label="YouTube">
                  <img src="/assets/social/youtube.svg" alt="YouTube" width="24" height="24" />
                </a>
                <a href="#" class="social-icon" aria-label="Instagram">
                  <img src="/assets/social/instagram.svg" alt="Instagram" width="24" height="24" />
                </a>
                <a href="#" class="social-icon" aria-label="TikTok">
                  <img src="/assets/social/tiktok.svg" alt="TikTok" width="24" height="24" />
                </a>
                <a href="#" class="social-icon" aria-label="Twitter">
                  <img src="/assets/social/twitter.svg" alt="Twitter" width="24" height="24" />
                </a>
                <a href="#" class="social-icon" aria-label="LinkedIn">
                  <img src="/assets/social/linkedin.svg" alt="LinkedIn" width="24" height="24" />
                </a>
                <a href="#" class="social-icon" aria-label="Facebook">
                  <img src="/assets/social/facebook.svg" alt="Facebook" width="24" height="24" />
                </a>
              </div>
            </div>
          </div>
          
          <div class="ologies-loading">
            <p>Loading ologies...</p>
          </div>
        </div>
      </div>
    `;

    try {
      // Fetch the ologies data from the Astro API
      await this.fetchOlogies();
      this.renderContent();
    } catch (error) {
      console.error('Error loading ologies:', error);
      this.showError('Failed to load ologies content');
    }
  }

  async fetchOlogies() {
    try {
      // Determine the correct API base URL
      let apiUrl;
      if (window.location.hostname === 'localhost') {
        // Development: Use the local Astro dev server
        apiUrl = 'http://localhost:4321/api/ologies.json';
      } else {
        // Production: Use the actual build location
        apiUrl = '/file/ologies/api/ologies.json';
      }
      
      // Try to fetch from the API endpoint for all ologies
      const response = await fetch(apiUrl);
      
      if (response.ok) {
        const data = await response.json();
        
        if (data.ologies && Array.isArray(data.ologies)) {
          this.ologies = data.ologies.map(ology => ({
            slug: ology.slug,
            data: {
              title: ology.title,
              type: ology.type,
              description: ology.description,
              publishDate: new Date(ology.publishDate),
              tags: ology.tags || [],
              featured: ology.featured || false,
              author: ology.author || 'Our Team',
              cardImage: ology.cardImage || '',
              cardTextColor: ology.cardTextColor || 'white'
            }
          }));
          
          this.filteredOlogies = [...this.ologies];
          return;
        }
      }
      
      // If API is not available, show error
      throw new Error(`API not available at ${apiUrl}`);
      
    } catch (error) {
      console.error('Failed to fetch ologies:', error);
      throw error;
    }
  }

  renderContent() {
    const types = ['all', ...new Set(this.ologies.map(o => o.data.type))];
    
    this.container.innerHTML = `
      <div class="ologies-wrapper">
        <div class="ologies-content-container">
          <div class="ologies-header">
            <h1><span class="ologies-title">'Ologies'</span> —is our content: the art-science of apps, design, and distribution.</h1>
            
            <div class="ologies-social">
              <span class="social-text">Follow us to stay in-the-know:</span>
              <div class="social-icons">
                <a href="#" class="social-icon" aria-label="YouTube">
                  <img src="/assets/social/youtube.svg" alt="YouTube" width="24" height="24" />
                </a>
                <a href="#" class="social-icon" aria-label="Instagram">
                  <img src="/assets/social/instagram.svg" alt="Instagram" width="24" height="24" />
                </a>
                <a href="#" class="social-icon" aria-label="TikTok">
                  <img src="/assets/social/tiktok.svg" alt="TikTok" width="24" height="24" />
                </a>
                <a href="#" class="social-icon" aria-label="Twitter">
                  <img src="/assets/social/twitter.svg" alt="Twitter" width="24" height="24" />
                </a>
                <a href="#" class="social-icon" aria-label="LinkedIn">
                  <img src="/assets/social/linkedin.svg" alt="LinkedIn" width="24" height="24" />
                </a>
                <a href="#" class="social-icon" aria-label="Facebook">
                  <img src="/assets/social/facebook.svg" alt="Facebook" width="24" height="24" />
                </a>
              </div>
            </div>
          </div>
          
          <div class="ologies-filters">
            <div class="search-container">
              <input 
                type="text" 
                id="ologies-search" 
                placeholder="Search ologies..." 
                value="${this.searchTerm}"
              />
            </div>
            <div class="filter-container">
              <div class="ologies-dropdown" id="ologies-type-filter" tabindex="0">
                <span class="dropdown-text">Allogies</span>
                <span class="material-symbols-sharp dropdown-icon">keyboard_arrow_down</span>
                <ul class="ologies-dropdown-menu" style="display: none;">
                  ${types.map(type => 
                    `<li data-value="${type}" ${type === this.selectedType ? 'class="selected"' : ''}>
                      ${type === 'all' ? 'Allogies' : type.charAt(0).toUpperCase() + type.slice(1)}
                    </li>`
                  ).join('')}
                </ul>
              </div>
            </div>
          </div>
          
          <div class="ologies-grid">
            ${this.filteredOlogies.map(ology => this.renderOlogyCard(ology)).join('')}
          </div>
          
          ${this.filteredOlogies.length === 0 ? '<div class="no-results">No ologies found matching your criteria.</div>' : ''}
        </div>
      </div>
    `;

    this.setupEventListeners();
  }

  renderOlogyCard(ology) {
    const { data, slug } = ology;
    const cardImage = data.cardImage || 'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExc2prbHNpeW9keDlnam9jdWVjOGdmaHhsZTFheThzeGt3MmJwYnM0OCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/xzgCWNwatU0bBWbV5d/giphy.gif';
    const textColor = data.cardTextColor || 'white';
    
    return `
      <article class="ology-card" data-slug="${slug}" data-text-color="${textColor}">
        <a href="/ologies/${slug}" class="ology-link" data-slug="${slug}" data-title="${data.title}">
          <div class="ology-card__background">
            <img 
              src="${cardImage}"
              alt="Background for ${data.title}"
              class="ology-card__gif"
            />
            <div class="ology-card__overlay"></div>
          </div>
          
          <div class="ology-card__content">
            <div class="ology-card__top">
              <span class="ology-card__type">${data.type}</span>
              <span class="ology-card__read">
                <span class="read-text">READ</span>
                <span class="read-arrow material-symbols-sharp">trending_flat</span>
              </span>
            </div>
            
            <div class="ology-card__bottom">
              <h3 class="ology-card__title">${data.title}</h3>
            </div>
          </div>
        </a>
      </article>
    `;
  }

  setupEventListeners() {
    // Search functionality
    const searchInput = this.container.querySelector('#ologies-search');
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        this.searchTerm = e.target.value;
        this.filterOlogies();
      });
    }

    // Custom dropdown functionality
    const dropdown = this.container.querySelector('#ologies-type-filter');
    const dropdownMenu = this.container.querySelector('.ologies-dropdown-menu');
    
    if (dropdown && dropdownMenu) {
      // Toggle dropdown
      dropdown.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = dropdownMenu.style.display === 'block';
        dropdownMenu.style.display = isOpen ? 'none' : 'block';
        dropdown.classList.toggle('open', !isOpen);
      });

      // Handle dropdown item selection
      dropdownMenu.addEventListener('click', (e) => {
        const item = e.target.closest('li');
        if (item) {
          const value = item.dataset.value;
          const text = item.textContent;
          
          // Update selected value
          this.selectedType = value;
          dropdown.querySelector('.dropdown-text').textContent = text;
          
          // Update selected state
          dropdownMenu.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
          item.classList.add('selected');
          
          // Close dropdown
          dropdownMenu.style.display = 'none';
          dropdown.classList.remove('open');
          
          // Filter ologies
          this.filterOlogies();
        }
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', () => {
        dropdownMenu.style.display = 'none';
        dropdown.classList.remove('open');
      });
    }

    // Ology link clicks
    this.container.addEventListener('click', (e) => {
      const link = e.target.closest('.ology-link');
      if (link) {
        e.preventDefault();
        
        const slug = link.dataset.slug;
        const title = link.dataset.title;
        
        // Open the ology in a new tab (preserves SPA behavior)
        this.openOlogyInTab(slug, title);
      }
    });
  }

  filterOlogies() {
    this.filteredOlogies = this.ologies.filter(ology => {
      const matchesSearch = !this.searchTerm || 
        ology.data.title.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        ology.data.description.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        (ology.data.tags && ology.data.tags.some(tag => 
          tag.toLowerCase().includes(this.searchTerm.toLowerCase())
        ));
      
      const matchesType = this.selectedType === 'all' || ology.data.type === this.selectedType;
      
      return matchesSearch && matchesType;
    });

    // Re-render the grid
    const grid = this.container.querySelector('.ologies-grid');
    const noResults = this.container.querySelector('.no-results');
    
    if (grid) {
      grid.innerHTML = this.filteredOlogies.map(ology => this.renderOlogyCard(ology)).join('');
    }
    
    // Show/hide no results message
    if (noResults) {
      noResults.style.display = this.filteredOlogies.length === 0 ? 'block' : 'none';
    } else if (this.filteredOlogies.length === 0) {
      const wrapper = this.container.querySelector('.ologies-content-container');
      if (wrapper) {
        wrapper.insertAdjacentHTML('beforeend', '<div class="no-results">No ologies found matching your criteria.</div>');
      }
    }
  }

  openOlogyInTab(slug, title) {
    // Create a custom event to open the ology in a new tab
    const openEvent = new CustomEvent('file:open', { 
      detail: { 
        filepath: `ologies/${slug}`,
        title: title || slug
      },
      bubbles: true 
    });
    document.dispatchEvent(openEvent);
  }

  showError(message) {
    const isLocalhost = window.location.hostname === 'localhost';
    
    this.container.innerHTML = `
      <div class="ologies-wrapper">
        <div class="ologies-content-container">
          <div class="ologies-header">
            <h1><span class="ologies-title">'Ologies'</span> —is our content: the art-science of apps, design, and distribution.</h1>
          </div>
          <div class="ologies-error">
            <h2>Unable to Load Ologies</h2>
            <p>${message}</p>
            ${isLocalhost ? `
              <p><strong>Development Setup:</strong></p>
              <ol>
                <li>Make sure the ologies server is running: <code>cd ologies-content && npm run dev</code></li>
                <li>Check that it's accessible at <a href="http://localhost:4321" target="_blank">http://localhost:4321</a></li>
                <li>Then reload this page</li>
              </ol>
            ` : `
              <p><strong>This appears to be a deployment issue.</strong></p>
              <p>The ologies content should be available at the same domain. Please check the build process.</p>
            `}
            <button onclick="window.location.reload()">Reload</button>
          </div>
        </div>
      </div>
    `;
  }

  destroy() {
    // Clean up any event listeners if needed
  }
} 